import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { TypeOfLoanStepComponent } from "../../wizard/wizard-steps/type-of-loan-step/type-of-loan-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class TypeOfLoanStep extends WizardStepBase {

  showChildCareQuestionsForVALoans: boolean = false;

  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = TypeOfLoanStepComponent;
  }
}
